import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import { DashboardContext } from '../../DashboardScene/DashboardContext';
import { NavSections, StyledNavLinks } from '../../DashboardScene/Nav';
import { StyledSettingsNav } from '../../DashboardScene/Nav/SettingsNav';
const SettingsNav = () => {
  const $ = _c(23);
  const {
    is_degraded_banner_active,
    team
  } = useContext(DashboardContext);
  const plans_path = team?.type === "outpost" ? "/settings/organization/outpost/plans" : "/settings/organization/plans";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      direction: "column"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      x: 2,
      y: 3
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavLink to="/settings/project/general"><Icon left={true} icon="settings" pointer={true} /><Text semi={true} size="m">General</Text></NavLink>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NavLink to="/settings/project/destinations"><Icon left={true} icon="destination" pointer={true} /><Text semi={true} size="m">Destinations</Text></NavLink>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NavLink to="/settings/project/monitoring"><Icon left={true} icon="search" pointer={true} /><Text semi={true} size="m">Monitoring</Text></NavLink>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NavLink to="/settings/project/user-portal"><Icon left={true} icon="portal" pointer={true} /><Text semi={true} size="m">User Portal</Text></NavLink>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <NavLink to="/settings/project/publishing"><Icon left={true} icon="send" pointer={true} /><Text semi={true} size="m">Publishing</Text></NavLink>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <NavLink to="/settings/project/secrets"><Icon left={true} icon="key" pointer={true} /><Text semi={true} size="m">API Keys</Text></NavLink>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <NavSections title="Project" collapsable={false} first={true}><StyledNavLinks>{t2}{t3}{t4}{t5}{t6}{t7}<NavLink to="/settings/project/access"><Icon left={true} icon="group" pointer={true} /><Text semi={true} size="m">Access Control</Text></NavLink></StyledNavLinks></NavSections>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <NavLink to="/settings/organization/general"><Icon left={true} icon="settings" pointer={true} /><Text semi={true} size="m">General</Text></NavLink>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <NavLink to="/settings/organization/members"><Icon left={true} icon="group" pointer={true} /><Text semi={true} size="m">Members</Text></NavLink>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <NavLink to="/settings/organization/api-keys"><Icon left={true} icon="key" pointer={true} /><Text semi={true} size="m">API Keys</Text></NavLink>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <NavLink to="/settings/organization/billing"><Icon left={true} icon="wallet" pointer={true} /><Text semi={true} size="m">Billing</Text></NavLink>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Icon left={true} icon="checklist" pointer={true} />;
    t14 = <Text semi={true} size="m">Plans</Text>;
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  if ($[15] !== plans_path) {
    t15 = <NavSections title="Organization" collapsable={false}><StyledNavLinks>{t9}{t10}{t11}{t12}<NavLink to={plans_path}>{t13}{t14}</NavLink></StyledNavLinks></NavSections>;
    $[15] = plans_path;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <NavSections title="Account" collapsable={false}><StyledNavLinks><NavLink to="/settings/account/profile"><Icon left={true} icon="account" pointer={true} /><Text semi={true} size="m">Profile</Text></NavLink></StyledNavLinks></NavSections>;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== t15) {
    t17 = <Div p={t1}>{t8}{t15}{t16}</Div>;
    $[18] = t15;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== is_degraded_banner_active || $[21] !== t17) {
    t18 = <StyledSettingsNav h={100} flex={t0} is_degraded_banner_active={is_degraded_banner_active}>{t17}</StyledSettingsNav>;
    $[20] = is_degraded_banner_active;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  return t18;
};
export default SettingsNav;